import setLocale from './set_locale';
import setAvailableLocales from './set_available_locales';

export default {
  setLocale,
  setAvailableLocales,
};
